import { axios, Response } from '..'

export interface Body {
  taskIds: string[]
}

export interface GetTasksInfoResponse {
  taskId: string
  userId: string
  username: string
  avatarUrl: string
}

export const getTasksInfo = (
  getTasksInfoRequest: Body
): Response<GetTasksInfoResponse[]> => {
  return axios.post('/v1/tasks/members', getTasksInfoRequest)
}
